







































































































































































































































import { Vue, Component } from "vue-property-decorator";
import axios from "axios";
import states from "@/assets/dictionaries/state-list.ts";
declare module "@/assets/dictionaries/state-list.ts";

@Component
export default class CreateExhibitor extends Vue {
    apiResponse = {
        status: 0,
        message: "",
    };
    states = states;
    productNameInput = "";
    keywordInput = "";
    formFields = {
        name: "",
        address: "",
        city: "",
        state: "",
        zip: "",
        country: "",
        logoURL: "",
        websiteURL: "",
        facebookURL: "",
        twitterURL: "",
        linkedinURL: "",
        instagramURL: "",
        companyDescription: "",
        productNames: [] as Array<string>,
        lookingToSell: false,
        lookingToHire: false,
        lookingForPartners: false,
        lookingForHostSession: false,
        keywords: [] as Array<string>,
    };

    /*TODO: Refactor gross code duplication into a separate UI component probably */
    addProduct(): void {
        if (this.productNameInput) {
            this.formFields.productNames.push(this.productNameInput);
        }
        this.productNameInput = "";
    }
    removeProduct(idx: number): void {
        this.formFields.productNames.splice(idx, 1);
    }
    addKeyword(): void {
        if (this.keywordInput) {
            this.formFields.keywords.push(this.keywordInput);
        }
        this.keywordInput = "";
    }
    removeKeyword(idx: number): void {
        this.formFields.keywords.splice(idx, 1);
    }
    submitForm(): void {
        axios
            .post(
                "https://vmp-back.azurewebsites.net/api/CreateExhibitor",
                this.formFields
            )
            .then((response) => {
                this.apiResponse.status = response.status;
            })
            .catch((error) => {
                this.apiResponse.status = error.response.status;
                this.apiResponse.message = error.response.data;
            });
    }
}
